/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Sensors_TitleInputs */

const vi_irrigation_sensors_title = /** @type {(inputs: Irrigation_Sensors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông số đất`)
};

/**

* @param {Irrigation_Sensors_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_sensors_title = /** @type {((inputs?: Irrigation_Sensors_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Sensors_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_sensors_title(inputs)
});